const WebsiteRedirect = ({ className, width = '14', height = '14' }) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width={width} height={height} rx="2" fill="#F9F9F9" />
    <path
      d="M10.2284 13.0584C9.59982 13.6869 9.28556 14.0012 9.28556 14.0012C7.98381 15.3029 7.98381 17.4135 9.28556 18.7152C10.5873 20.017 12.6979 20.017 13.9996 18.7152C13.9996 18.7152 14.3139 18.401 14.9424 17.7724"
      stroke="#3C3C3B"
      strokeWidth="0.8"
      strokeLinecap="square"
    />
    <path
      d="M12.1133 15.8867L15.8845 12.1155"
      stroke="#3C3C3B"
      strokeWidth="0.8"
      strokeLinecap="square"
    />
    <path
      d="M17.7716 14.9416C18.4002 14.3131 18.7144 13.9988 18.7144 13.9988C20.0162 12.6971 20.0162 10.5865 18.7144 9.28476C17.4127 7.98301 15.3021 7.98301 14.0004 9.28476C14.0004 9.28476 13.6861 9.59903 13.0576 10.2276"
      stroke="#3C3C3B"
      strokeWidth="0.8"
      strokeLinecap="square"
    />
  </svg>
);

export default WebsiteRedirect;
